import React from 'react';
import CountUp from 'react-countup';

const componentName = ({ title, countUpData, imgSrc}) => {
    return (
        <div className="col-xl-3 col-lg-6  pb-3">
        <div className="card card-inverse counter_card ">
            <div className="card-block p-2 counter_area">
                <p className="text-muted">{title}</p>
                <div className="divider"></div>
                <h5 className="cs_primary"><CountUp end={countUpData}/>  BDT</h5>
                <img className='dashboard_counter_icon' src={imgSrc} alt={title} srcSet="" />
            </div>
        </div>
    </div>
    );
};

export default componentName;